var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [
    [_c('h3', [_vm._v("树形视图")]), _vm._v(" "), _c('div', {
      staticClass: "bs-docs-section"
    }, [_c('blockquote', [_c('p', [_vm._v("树形视图（普通）")])]), _vm._v(" "), _c('div', {
      staticClass: "bs-example"
    }, [_c('n3-tree', {
      attrs: {
        "data": _vm.data,
        "props": _vm.defaultProps
      },
      on: {
        "node-click": _vm.handleNodeClick
      }
    })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('blockquote', [_c('p', [_vm._v("树形视图（可选中、动态加载）")])]), _vm._v(" "), _c('div', {
      staticClass: "bs-example"
    }, [_c('n3-tree', {
      attrs: {
        "data": _vm.regions,
        "props": _vm.props,
        "load": _vm.loadNode,
        "lazy": "",
        "show-checkbox": ""
      },
      on: {
        "check-change": _vm.handleCheckChange
      }
    })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('h3', [_vm._v("参数")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('h3', [_vm._v("数据属性props")]), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('h3', [_vm._v("Methods")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('h3', [_vm._v("Events")]), _vm._v(" "), _vm._m(7)], 1)]
  ], 2)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":data")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"data\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":props")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"defaultProps\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@node-click")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"handleNodeClick\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n  data() {\n    "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("data")]), _vm._v(": [{\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹1'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'我的文档1'")]), _vm._v("\n        }]\n      }, {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹2'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'我的文档2'")]), _vm._v("\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'我的文档3'")]), _vm._v("\n        }]\n      }, {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹3'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹4'")]), _vm._v(",\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": [{\n            "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'我的文档6'")]), _vm._v("\n          }]\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'我的文档4'")]), _vm._v("\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'我的文档5'")]), _vm._v("\n        }]\n      }],\n      "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("defaultProps")]), _vm._v(": {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'children'")]), _vm._v(",\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'label'")]), _vm._v("\n      }\n    }\n  },\n  "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("methods")]), _vm._v(": {\n    handleNodeClick(data) {\n      "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log(data)\n    }\n  }\n}\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-html"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("<"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":data")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"regions\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":props")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"props\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v(":load")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"loadNode\"")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("lazy")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("show-checkbox")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("@check-change")]), _vm._v("="), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("\"handleCheckChange\"")]), _vm._v(">")]), _c('span', {
    attrs: {
      "class": "hljs-tag"
    }
  }, [_vm._v("</"), _c('span', {
    attrs: {
      "class": "hljs-name"
    }
  }, [_vm._v("n3-tree")]), _vm._v(">")]), _vm._v("\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pre', {
    pre: true
  }, [_c('code', {
    attrs: {
      "v-pre": "",
      "class": "language-javascript"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("export")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("default")]), _vm._v(" {\n    data() {\n      "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" {\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("defaultProps")]), _vm._v(": {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'children'")]), _vm._v(",\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'label'")]), _vm._v("\n        },\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("regions")]), _vm._v(": [{\n          "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'name'")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/root'")]), _vm._v("\n        }, {\n          "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'name'")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/home'")]), _vm._v("\n        }],\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("props")]), _vm._v(": {\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("label")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'name'")]), _vm._v(",\n          "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("children")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'zones'")]), _vm._v("\n        },\n        "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("count")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("1")]), _vm._v("\n      }\n    },\n    "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("methods")]), _vm._v(": {\n      handleCheckChange(data, checked, indeterminate) {\n        "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("console")]), _vm._v(".log(data, checked, indeterminate)\n      },\n      loadNode(node, resolve) {\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.level === "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("0")]), _vm._v(") {\n          "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" resolve([{ "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/root'")]), _vm._v(" }, { "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/home'")]), _vm._v(" }])\n        }\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.level > "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("3")]), _vm._v(") "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("return")]), _vm._v(" resolve([])\n\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("var")]), _vm._v(" hasChild\n        "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.data.name === "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/root'")]), _vm._v(") {\n          hasChild = "), _c('span', {
    attrs: {
      "class": "hljs-literal"
    }
  }, [_vm._v("true")]), _vm._v("\n        } "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("else")]), _vm._v(" "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (node.data.name === "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'/home'")]), _vm._v(") {\n          hasChild = "), _c('span', {
    attrs: {
      "class": "hljs-literal"
    }
  }, [_vm._v("false")]), _vm._v("\n        } "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("else")]), _vm._v(" {\n          hasChild = "), _c('span', {
    attrs: {
      "class": "hljs-built_in"
    }
  }, [_vm._v("Math")]), _vm._v(".random() > "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("0.5")]), _vm._v("\n        }\n\n        setTimeout("), _c('span', {
    attrs: {
      "class": "hljs-function"
    }
  }, [_c('span', {
    attrs: {
      "class": "hljs-params"
    }
  }, [_vm._v("()")]), _vm._v(" =>")]), _vm._v(" {\n          "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("var")]), _vm._v(" data\n          "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("if")]), _vm._v(" (hasChild) {\n            data = [{\n              "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹'")]), _vm._v(" + "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".count++\n            }, {\n              "), _c('span', {
    attrs: {
      "class": "hljs-attr"
    }
  }, [_vm._v("name")]), _vm._v(": "), _c('span', {
    attrs: {
      "class": "hljs-string"
    }
  }, [_vm._v("'新建文件夹'")]), _vm._v(" + "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("this")]), _vm._v(".count++\n            }]\n          } "), _c('span', {
    attrs: {
      "class": "hljs-keyword"
    }
  }, [_vm._v("else")]), _vm._v(" {\n            data = []\n          }\n\n          resolve(data)\n        }, "), _c('span', {
    attrs: {
      "class": "hljs-number"
    }
  }, [_vm._v("500")]), _vm._v(")\n      }\n    }\n  }\n")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("data")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("[]")])]), _vm._v(" "), _c('td', [_vm._v("展示数据")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("empty-text")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("Empty Content.")]), _vm._v(" "), _c('td', [_vm._v("展示数据为空时展示的文本")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("node-key")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("每个树节点用来作为唯一标识的属性，整颗树应该是唯一的")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("props")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Object")])]), _vm._v(" "), _c('td', [_vm._v("—")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("leaf-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("file")]), _vm._v(" "), _c('td', [_vm._v("叶子节点图标")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("child-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("folder")]), _vm._v(" "), _c('td', [_vm._v("子节点图标")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("closed-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("angle-right")]), _vm._v(" "), _c('td', [_vm._v("关闭时箭头图标")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("opened-icon")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("angle-down")]), _vm._v(" "), _c('td', [_vm._v("打开时箭头图标")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("load")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("function(node, resolve) {}")]), _vm._v(" "), _c('td', [_vm._v("加载子树数据的方法")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("render-content")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("function(h, { node }) {}")]), _vm._v(" "), _c('td', [_vm._v("树节点的内容区的渲染方法")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("highlight-current")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("是否高亮当前选中节点")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("current-node-key")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String, Number")])]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("当前选中节点的 key ，只写属性")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-expand-all")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("是否默认展开所有节点")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("expand-on-click-node")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("true")])]), _vm._v(" "), _c('td', [_vm._v("是否在点击节点的时候展开或者收缩节点(如果不则则只有点箭头图标的时候才会展开或者收缩节点。)")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("auto-expand-parent")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-expanded-keys")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_vm._v("—")]), _vm._v(" "), _c('td', [_vm._v("默认展开的节点的 key 的数组")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("show-checkbox")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("节点是否可被勾选")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("check-strictly")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Boolean")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("false")])]), _vm._v(" "), _c('td', [_vm._v("在显示复选框的情况下，是否严格的遵循父子不互相关联的做法")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("default-checked-keys")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Array")])]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("[]")])]), _vm._v(" "), _c('td', [_vm._v("默认勾选的节点的 key 的数组")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("filter-node-method")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("Function")])]), _vm._v(" "), _c('td', [_vm._v("function(value, data, node)")]), _vm._v(" "), _c('td', [_vm._v("对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示, 反之则为隐藏")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("参数名")]), _vm._v(" "), _c('th', [_vm._v("类型")]), _vm._v(" "), _c('th', [_vm._v("默认值")]), _vm._v(" "), _c('th', [_vm._v("说明")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_vm._v("指定节点标签为节点对象的某个属性值")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("children")]), _vm._v(" "), _c('td', [_c('code', {
    pre: true
  }, [_vm._v("String")])]), _vm._v(" "), _c('td', [_vm._v("children")]), _vm._v(" "), _c('td', [_vm._v("指定子树为节点对象的某个属性值")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("方法名")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("filter")]), _vm._v(" "), _c('td', [_vm._v("对树节点进行筛选操作")]), _vm._v(" "), _c('td', [_vm._v("接收一个任意类型的参数，该参数会在 filter-node-method 中作为第一个参数")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("getCheckedNodes")]), _vm._v(" "), _c('td', [_vm._v("若节点可被选择（即 "), _c('code', {
    pre: true
  }, [_vm._v("show-checkbox")]), _vm._v(" 为 "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v("），则返回目前被选中的节点所组成的数组")]), _vm._v(" "), _c('td', [_vm._v("(leafOnly) 接收一个 boolean 类型的参数，若为 "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v(" 则仅返回被选中的叶子节点，默认值为 "), _c('code', {
    pre: true
  }, [_vm._v("false")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("setCheckedNodes")]), _vm._v(" "), _c('td', [_vm._v("设置目前勾选的节点，使用此方法必须设置 node-key 属性")]), _vm._v(" "), _c('td', [_vm._v("(nodes) 接收勾选节点数据的数组")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("getCheckedKeys")]), _vm._v(" "), _c('td', [_vm._v("若节点可被选择（即 "), _c('code', {
    pre: true
  }, [_vm._v("show-checkbox")]), _vm._v(" 为 "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v("），则返回目前被选中的节点所组成的数组")]), _vm._v(" "), _c('td', [_vm._v("(leafOnly) 接收一个 boolean 类型的参数，若为 "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v(" 则仅返回被选中的叶子节点的 keys，默认值为 "), _c('code', {
    pre: true
  }, [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("setCheckedKeys")]), _vm._v(" "), _c('td', [_vm._v("通过 keys 设置目前勾选的节点，使用此方法必须设置 node-key 属性")]), _vm._v(" "), _c('td', [_vm._v("(keys, leafOnly) 接收两个参数，1. 勾选节点的 key 的数组 2. boolean 类型的参数，若为 "), _c('code', {
    pre: true
  }, [_vm._v("true")]), _vm._v(" 则仅设置叶子节点的选中状态，默认值为 "), _c('code', {
    pre: true
  }, [_vm._v("true")])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("setChecked")]), _vm._v(" "), _c('td', [_vm._v("通过 key / data 设置某个节点的勾选状态，使用此方法必须设置 node-key 属性")]), _vm._v(" "), _c('td', [_vm._v("(key/data, checked, deep) 接收三个参数，1. 勾选节点的 key 或者 data 2. boolean 类型，节点是否选中  3. boolean 类型，是否设置子节点 ，默认为 false")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', [_c('thead', [_c('tr', [_c('th', [_vm._v("事件名称")]), _vm._v(" "), _c('th', [_vm._v("说明")]), _vm._v(" "), _c('th', [_vm._v("回调参数")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("node-click")]), _vm._v(" "), _c('td', [_vm._v("节点被点击时的回调")]), _vm._v(" "), _c('td', [_vm._v("共三个参数，依次为：传递给 "), _c('code', {
    pre: true
  }, [_vm._v("data")]), _vm._v(" 属性的数组中该节点所对应的对象、节点对应的 Node、节点组件本身。")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("check-change")]), _vm._v(" "), _c('td', [_vm._v("节点选中状态发生变化时的回调")]), _vm._v(" "), _c('td', [_vm._v("共三个参数，依次为：传递给 "), _c('code', {
    pre: true
  }, [_vm._v("data")]), _vm._v(" 属性的数组中该节点所对应的对象、节点本身是否被选中、节点的子树中是否有被选中的节点")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("current-change")]), _vm._v(" "), _c('td', [_vm._v("当前选中节点变化时触发的事件")]), _vm._v(" "), _c('td', [_vm._v("共两个参数，依次为：当前节点的数据，当前节点的 Node 对象")])])])])
}]
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-9981bef0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9981bef0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-markdown-loader/lib/markdown-compiler.js?raw!./docs/example_zh/n3TreeDocs.md
// module id = 925
// module chunks = 0